
window.Vue = require('vue');

window.axios = require('axios');

Vue.component('site-navigation', require('./components/SiteNavigation.vue').default);
Vue.component('main-nav-toggle', require('./components/MainNavToggle.vue').default);
Vue.component('product-variants', require('./components/ProductVariants.vue').default);
Vue.component('product-variant', require('./components/ProductVariant.vue').default);
Vue.component('entry-slider', require('./components/EntrySlider.vue').default);
Vue.component('carousel-slide', require('./components/Slide.vue').default);
Vue.component('my-carousel', require('./components/Carousel.vue').default);


// Fullpage.js
//import 'fullpage.js/vendors/scrolloverflow' // Optional. When using scrollOverflow:true
//import './fullpage.scrollHorizontally.min' // Optional. When using fullpage extensions
import VueFullPage from 'vue-fullpage.js'
import VueCarousel from 'vue-carousel';

Vue.use(VueFullPage);
Vue.use(VueCarousel);

const app = new Vue({
    el: '#app',
    data: {
        showNav: false,
    }
});
